import { Component, HostBinding, Inject, Input } from '@angular/core';
import { UtilsConfig } from '../../models';

@Component({
  selector: 'app-anecdotes-footer',
  templateUrl: './anecdotes-footer.component.html',
  styleUrls: ['./anecdotes-footer.component.scss'],
})
export class AnecdotesFooterComponent {
  @HostBinding('class.no-background')
  @Input()
  noBackground: boolean;

  readonly anecdotesUrl = this.utilsConfig.anecdotesUrl;

  constructor(@Inject('utils-config') private utilsConfig: UtilsConfig) {}

  buildTranslationKey(relativeKey: string): string {
    return `anecdotes-footer.${relativeKey}`;
  }
}
